import { createSelector } from '@ngrx/store';
import { getAdditionalServicesState } from './state.selector';

export const getDeclineProtectionState = createSelector(
  getAdditionalServicesState,
  (state) => state?.declineProtection
);

export const isDeclineProtectionSelected = createSelector(
  getDeclineProtectionState,
  (state) => !!state?.data
);
